/**
 * Centralized destructive-action confirm (P2-FE-005).
 * Single gate so every delete/publish/rollback asks before mutating.
 * Uses window.confirm for reliability across QA pages without per-page dialog mounts.
 */
export function confirmQaDestructive({
  action = 'proceed',
  subject = 'this item',
  detail = '',
} = {}) {
  const lines = [
    `Confirm ${action}?`,
    String(subject || '').trim(),
    String(detail || '').trim(),
    'This cannot always be undone.',
  ].filter(Boolean);
  return window.confirm(lines.join('\n\n'));
}

export function useQaConfirm() {
  return { confirmDestructive: confirmQaDestructive };
}
